import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import { changeNum } from './common/function';

function UpgradeSetting() {
    const [page, setPage] = useState(1)
    const [page1, setPage1] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    let dark = useSelector((state) => { return state.Darkmode.value });

    const [tabData, setTabData] = useState([])
    const [energyData, setEnergyData] = useState([])
    const [guideData, setGuideData] = useState([])
    const [dianModal, setDiaModal] = useState(false)
    const [clickId, setClickId] = useState([])

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        setPage(1)
        setPage1(1)
        UpgradeData()
        GuideData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/up', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                let Data = tmp?.data?.upgrade['energy-limit'] ?? []

                setTabData(Data.filter((item) => item.up_type === 'tab-plus'));
                setEnergyData(Data.filter((item) => item.up_type === 'energy-limit'));

                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    const GuideData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/up/guide', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setGuideData(tmp?.data?.upgrade ?? [])
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    let slice_tabData = tabData.slice((page - 1) * 20, (page) * 20)
    let slice_energyData = energyData.slice((page1 - 1) * 20, (page1) * 20)

    return (
        <div className='main'>
            <Message message={message} />
            {dianModal && (<DiaModal dark={dark} darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}

            <div className={`main-box ${darkname}`} style={{ display: 'flex', gap: '50px' }}>
                <div>
                    <div className='maintab'>
                        <div className={`maintab-btn on ${darkname}`}>tab-plus</div>
                    </div>
                    <div className='main-upgrade-guide'>
                        <div className='main-upgrade-guide-input'>{
                            guideData[0]?.upgrade_desc ?? ""
                        }</div>
                    </div>
                    <div className={`member-2 ${darkname}`} style={{ width: "600px" }}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "20%", minWidth: "50px" }}>강화명</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>레벨</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>밸류</div>
                            <div style={{ width: "30%", minWidth: "50px" }}>비용</div>
                            <div style={{ width: "10%", minWidth: "80px" }}></div>
                        </div>
                        <div className='table-body' style={{ minHeight: "600px" }}>
                            {
                                spinner
                                    ?
                                    <div className='spinner-modal'>
                                        <SyncLoader color="#003577" />
                                    </div>
                                    :
                                    slice_tabData.length === 0
                                        ?
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png'></img>
                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                        :
                                        <>
                                            <UpgradeAdd darkname={darkname} dark={dark} setReload={setReload} btn={0} Data={tabData} />
                                            {
                                                slice_tabData.map(function (a, i) {
                                                    return (
                                                        <MemberItem key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} setClickId={setClickId} setDiaModal={setDiaModal} />
                                                    )
                                                })
                                            }
                                            <NewPage initialData={tabData} page={page} setPage={setPage} maxFirstPage={20} />
                                        </>
                            }
                        </div>
                    </div>
                </div>
                <div>
                    <div className='maintab'>
                        <div className={`maintab-btn on ${darkname}`}>energy-limit</div>
                    </div>
                    <div className='main-upgrade-guide'>
                        <div className='main-upgrade-guide-input'>{
                            guideData[1]?.upgrade_desc ?? ""
                        }</div>
                    </div>
                    <div className={`member-2 ${darkname}`} style={{ width: "600px" }}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "20%", minWidth: "50px" }}>강화명</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>레벨</div>
                            <div style={{ width: "20%", minWidth: "50px" }}>밸류</div>
                            <div style={{ width: "30%", minWidth: "50px" }}>비용</div>
                            <div style={{ width: "10%", minWidth: "80px" }}></div>
                        </div>
                        <div className='table-body' style={{ minHeight: "600px" }}>
                            {
                                spinner
                                    ?
                                    <div className='spinner-modal'>
                                        <SyncLoader color="#003577" />
                                    </div>
                                    :
                                    slice_energyData.length === 0
                                        ?
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png'></img>
                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                        :
                                        <>
                                            <UpgradeAdd darkname={darkname} dark={dark} setReload={setReload} btn={1} Data={energyData} />
                                            {
                                                slice_energyData.map(function (a, i) {
                                                    return (
                                                        <MemberItem key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} setClickId={setClickId} setDiaModal={setDiaModal} />
                                                    )
                                                })
                                            }
                                            <NewPage initialData={energyData} page={page1} setPage={setPage1} maxFirstPage={20} />
                                        </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function UpgradeAdd({ darkname, dark, setReload, btn, Data }) {
    const [formData, setFormData] = useState({
        upType: btn === 0 ? "tab-plus" : "energy-limit",
        upLevel: Data.length + 1,
        upValue: "",
        upPrice: "",
    });

    useEffect(() => {
        setFormData({
            upType: btn === 0 ? "tab-plus" : "energy-limit",
            upLevel: Data.length + 1,
            upValue: "",
            upPrice: "",
        })
    }, [btn])
    
    const handleInputChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    const onClickData = async () => {
        await axios
            .post(process.env.REACT_APP_API + "/api/up", formData)
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setReload((e) => !e);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="left td" style={{ width: "20%", minWidth: "50px" }}>
                    {formData.upType}
                </div>
                <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                    {formData.upLevel}
                </div>
                <div className="right td" style={{ width: "20%", minWidth: "50px" }}>
                    <input
                        type="text"
                        value={formData.upValue}
                        onChange={(e) => handleInputChange("upValue", e.target.value)}
                    />
                </div>
                <div className="right td" style={{ width: "30%", minWidth: "50px" }}>
                    <input
                        type="text"
                        value={formData.upPrice}
                        onChange={(e) => handleInputChange("upPrice", e.target.value)}
                    />
                </div>
                <div className="td" style={{ width: "10%", minWidth: "80px" }}>
                    <div className="upgrade-btn" onClick={onClickData} style={{ backgroundColor: "#003577", color: "#fff" }}>
                        추가
                    </div>
                </div>
            </div>
        </>
    );
}


function MemberItem({ item, darkname, dark, setClickId, setDiaModal }) {
    const onClickData = () => {
        setClickId(item);
        setDiaModal(true)
    }
    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='left td' style={{ width: "20%", minWidth: "50px" }}>{item.up_type}</div>
                <div className='right td' style={{ width: "20%", minWidth: "50px" }}>{changeNum(item.up_level)}</div>
                <div className='right td' style={{ width: "20%", minWidth: "50px" }}>{changeNum(item.up_value)}</div>
                <div className='right td' style={{ width: "30%", minWidth: "50px" }}>{changeNum(item.up_price)}</div>
                <div className='td' style={{ width: "10%", minWidth: "80px" }}>
                    <div className="upgrade-btn" onClick={() => onClickData()}>수정</div>
                </div>
            </div>
        </>
    )
}

function DiaModal({ dark, darkname, setDiaModal, clickId, setReload }) {
    const [input, setInput] = useState(clickId.up_value)
    const [input1, setInput1] = useState(clickId.up_price)

    const onChangeInput = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInput(onlyNumber)
    }
    const onChangeInput1 = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInput1(onlyNumber)
    }


    const onSubmitUpdate = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/up/update", {
            upId: clickId.id,
            upValue: input,
            upPrice: input1
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code == 1000) {
                    setDiaModal(false);
                    setReload((e) => !e);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };


    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "460px" }}>
                    <div className="modal-1-header">강화 수정 (레벨: {clickId.up_level})</div>
                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>기존 밸류: {changeNum(clickId.up_value)}</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} onChange={onChangeInput} placeholder='수정된 밸류' />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>기존 비용: {changeNum(clickId.up_price)}</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input1} onChange={onChangeInput1} placeholder='수정된 비용' />
                            </div>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>
                            취소
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => onSubmitUpdate(true)}>
                            수정
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UpgradeSetting;